// Three terminal-style stills carrying the voice → YAML → run thesis. V1 is
// static (the 30-second demo video itself is a pre-launch artifact-to-be-
// produced per the shape brief's open questions). When the video exists, the
// middle still gains a play-button overlay and opens a lightbox modal.

const STILLS = [
  {
    title: 'cairn record',
    caption: 'Voice walkthrough',
    body: [
      { color: 'schist', text: '$ cairn record login' },
      { color: 'limestone', text: 'Recording…' },
      { color: 'slate', text: '"On the sign-in screen,' },
      { color: 'slate', text: ' I type my email…"' },
      { color: 'schist', text: '✓ Transcribed' },
      { color: 'schist', text: '✓ Extracted graph' },
      { color: 'terracotta', text: '→ .graphs/login.yaml' },
    ],
  },
  {
    title: '.graphs/login.yaml',
    caption: 'Versioned spec',
    body: [
      { color: 'schist', text: 'apiVersion: cairntools.com/v1alpha1' },
      { color: 'schist', text: 'kind: Flow' },
      { color: 'limestone', text: 'spec:' },
      { color: 'limestone', text: '  entry: home' },
      { color: 'limestone', text: '  nodes:' },
      { color: 'limestone', text: '    home:' },
      { color: 'slate', text: '      route: /' },
      { color: 'slate', text: '      asserts:' },
      { color: 'slate', text: '        - role: button' },
      { color: 'slate', text: '          text: Sign in' },
    ],
  },
  {
    title: 'cairn run',
    caption: 'Tests + drift detection',
    body: [
      { color: 'schist', text: '$ cairn run login' },
      { color: 'passed', text: '✓ home → click Sign in' },
      { color: 'passed', text: '✓ login → type email' },
      { color: 'passed', text: '✓ login → type password' },
      { color: 'passed', text: '✓ dashboard rendered' },
      { color: 'schist', text: '' },
      { color: 'schist', text: '4 nodes · 0 drift · 240ms' },
      { color: 'terracotta', text: '→ passed' },
    ],
  },
]

const COLOR_CLASS = {
  schist: 'text-[var(--color-schist)]',
  slate: 'text-[var(--color-sandstone)]',
  limestone: 'text-[var(--color-limestone)]',
  passed: 'text-[var(--color-passed)]',
  terracotta: 'text-[var(--color-terracotta-soft)]',
}

function Still({ still }) {
  return (
    <figure className="overflow-hidden rounded-md bg-[var(--color-basalt)] shadow-lg">
      <div className="flex items-center gap-2 border-b border-[var(--color-slate)]/40 bg-[var(--color-basalt)] px-4 py-2">
        <span className="h-2.5 w-2.5 rounded-full bg-[var(--color-slate)]/60" aria-hidden="true" />
        <span className="h-2.5 w-2.5 rounded-full bg-[var(--color-slate)]/60" aria-hidden="true" />
        <span className="h-2.5 w-2.5 rounded-full bg-[var(--color-slate)]/60" aria-hidden="true" />
        <span className="ml-2 truncate font-mono text-[11px] text-[var(--color-schist)]">
          {still.title}
        </span>
      </div>
      <div className="px-4 py-4 font-mono text-[11px] leading-snug">
        {still.body.map((line, i) => (
          <div
            // biome-ignore lint/suspicious/noArrayIndexKey: static ordered lines
            key={i}
            className={`whitespace-pre ${COLOR_CLASS[line.color] ?? 'text-[var(--color-sandstone)]'}`}
          >
            {line.text || ' '}
          </div>
        ))}
      </div>
      <figcaption className="border-t border-[var(--color-slate)]/40 px-4 py-2 text-[11px] uppercase tracking-wider text-[var(--color-schist)]">
        {still.caption}
      </figcaption>
    </figure>
  )
}

export function HeroFilmstrip() {
  return (
    <div className="grid w-full gap-4 md:grid-cols-3">
      {STILLS.map((still) => (
        <Still key={still.title} still={still} />
      ))}
    </div>
  )
}
